module.exports = __webpack_public_path__ + "img/appAsset-cardbrand--Diners.fbcbd336.svg";